import produce from "immer"
import { ASC } from "const"
import { CcRequirementReviewMethod } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initCcRequirementReviewMethod: CcRequirementReviewMethod = {
    id: null,
    accountId: null,
    projectId: null,
    name: "",
    description: "",
    creator: null,
    default: false,
}

const initCcRequirementReviewMethodState: types.CcRequirementReviewMethodState = {
    methodList: {},
    methodIds: [],
    methodEdit: initCcRequirementReviewMethod,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadEdit: true,
}

const ccRequirementReviewMethodReducer = produce((
    draft: types.CcRequirementReviewMethodState = initCcRequirementReviewMethodState,
    action: ActionTypes = null,
): types.CcRequirementReviewMethodState => {
    switch (action.type) {
        case types.CC_REQUIREMENT_REVIEW_METHOD_LIST:
            draft.methodList = action.methodList
            return draft

        case types.CC_REQUIREMENT_REVIEW_METHOD_IDS:
            draft.methodIds = action.methodIds
            return draft

        case types.CC_REQUIREMENT_REVIEW_METHOD_EDIT:
            draft.methodEdit = action.method
            return draft

        case types.CC_REQUIREMENT_REVIEW_METHOD_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.CC_REQUIREMENT_REVIEW_METHOD_FILTERS:
            draft.filters = action.filters
            return draft

        case types.CC_REQUIREMENT_REVIEW_METHOD_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.CC_REQUIREMENT_REVIEW_METHOD_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default ccRequirementReviewMethodReducer
